import React from 'react';
import {
  Location,
  Navigator,
  UNSAFE_DataRouterContext,
  UNSAFE_NavigationContext,
  useLocation,
  useNavigate,
} from 'react-router';

import { QueryParamAdapter, QueryParamAdapterComponent } from 'use-query-params';

// Port of use-query-params' react-router-6 adapter, which imports from the removed react-router-dom package.
// BrowserRouter's navigator is the history object, whose live location is read at setQuery time.
export const ReactRouterAdapter: QueryParamAdapterComponent = ({ children }) => {
  const { navigator } = React.useContext(UNSAFE_NavigationContext);
  const liveLocation = (navigator as Navigator & { location?: Location }).location;
  const navigate = useNavigate();
  const router = React.useContext(UNSAFE_DataRouterContext)?.router;
  const location = useLocation();

  const adapter: QueryParamAdapter = {
    get location() {
      return router?.state?.location ?? liveLocation ?? location;
    },
    push(nextLocation) {
      navigate(nextLocation.search || '?', { replace: false, state: nextLocation.state });
    },
    replace(nextLocation) {
      navigate(nextLocation.search || '?', { replace: true, state: nextLocation.state });
    },
  };

  return children(adapter);
};
